<template>
    <div class="SortingContainer">
        <div class="SortingLabel" @click="ClickSortingButton" >{{ Label }}</div>
        <div class="SortingIndicatorContainer">
            <div v-if="IsSorting === true">
                <div v-if="IsDesc === true">↓</div>
                <div v-if="IsDesc === false">↑</div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        Label: String,
        SortingType: Number,
        OnClick: Function,
        IsSorting: Boolean,
        IsDesc: Boolean,
    },
    methods:{
        ClickSortingButton()
        {
            this.OnClick(this.SortingType);
        }
    },
}
</script>

<style>
.SortingContainer
{
    display: flex;
    width: 100px;
}

.SortingLabel
{
    white-space: nowrap;
    cursor: pointer;
    flex: 0.8;
    text-align: right;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.SortingLabel:hover
{
    color: rgb(135,190,177);
}

.SortingIndicatorContainer
{
    flex: 1;
    margin-left: 10px;
}
</style>